module.exports = "<section class=\"screen screen--feedback active\">\r\n\r\n  <p class=\"first\">\r\n    <span class=\"head\">Dank je wel.</span>\r\n    Fijn dat je dit aan ons laat weten. We gaan ermee aan de slag.\r\n  </p>\r\n\r\n  <img class=\"emoji\" src=\"assets/images/emoji-hand.png\">\r\n\r\n  <p *ngIf=\"form.theme == 'ziggo'\">\r\n    We proberen komende week contact met je te zoeken.\r\n  </p>\r\n\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/screen-finish/screen-finish.component.html
// module id = ../../../../../src/app/screen-finish/screen-finish.component.html
// module chunks = main